module.exports = __webpack_public_path__ + "static/media/star-1.d3342d56.svg";